export class AuditorAuditeePermissionDeptWiseBean {
    roleId: number;
    roleName: string;
    deptId: number;
    deptName: string;
    auditeeEmail: string;
    accessDept: string;
    auditeeUserName: string;
    ncPermissionUsers: string;
}

